import * as Sentry from '@sentry/react';

/**
 * Sentry v8+: performance tracing via `browserTracingIntegration`.
 * (@sentry/tracing v7 is not mixed with @sentry/react v8.)
 */
export const initSentry = () => {
  if (!process.env.REACT_APP_SENTRY_DSN) return;
  if (process.env.NODE_ENV === 'development') return;

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_VERSION ?? 'unknown',
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection captured',
      'Network request failed',
      'Load failed',
      'AbortError',
    ],
    beforeSend(event) {
      if (event.user) {
        delete event.user.email;
        delete event.user.ip_address;
      }
      return event;
    },
  });
};

export const setSentryUser = (user) => {
  if (!process.env.REACT_APP_SENTRY_DSN) return;
  Sentry.setUser(user ? { id: user.id } : null);
};

export const captureError = (error, context = {}) => {
  if (!process.env.REACT_APP_SENTRY_DSN) return;
  Sentry.captureException(error, { extra: context });
};
